module.exports = __webpack_public_path__ + "media/images/icons/icons_large/6_bell-acd5e696e13845210af1ed68039eb7b7.png";